// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { LocationFilterModel } from "@store/Framework/Types/ApiModels";
import LocationFiltersState from "@store/Framework/Store/Greif/Components/LocationFilters/LocationFiltersState";
import { Draft } from "immer";

const initialState: LocationFiltersState = {
    locations: [],
    status: "notLoaded",
};

const actions = {
    "Greif/Components/LocationFilters/BeginLoadGreifLocations": (draft: Draft<LocationFiltersState>) => {
        draft.status = "loading";
    },

    "Greif/Components/LocationFilters/CompleteLoadGreifLocations": (
        draft: Draft<LocationFiltersState>,
        action: { locations: LocationFilterModel[] },
    ) => {
        draft.locations = action.locations;
        draft.status = "loaded";
    },

    "Greif/Components/LocationFilters/FailLoadGreifLocations": (draft: Draft<LocationFiltersState>) => {
        draft.status = "notLoaded";
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsLocationFiltersActions = Parameters<typeof reducer>[1];
export default reducer;
